<template>
  <div class="slot-filters" v-if="availableSlotsByVisitType && availableSlotsByVisitType.length > 0">
    <SlotFiltersByLocationEtc :week-index="Number(myWeek)" @doFilters="filterLocationEtc($event)" />
    <SlotFiltersByDays :page-index="Number(myPage)" @doFilters="filterPage($event)" />
  </div>
</template>


<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { SLOTS_COLUMNS, SLOTS_FILTER, SLOTS_STORE_DATA } from '@/store/_commons';
import SlotFiltersByLocationEtc from '@/components/reservation/slots/SlotFiltersByLocationEtc';
import SlotFiltersByDays from '@/components/reservation/slots/SlotFiltersByDays';

// Vuex store
const store = useStore();

// Reactive state
const myLocation = ref('');
const myTime = ref('');
const myWeek = ref(0);
const myPage = ref(0);
const byXDays = ref(false);
const numOfCol = ref(0);

// Computed properties
const slotsStates = computed(() => store.getters[SLOTS_STORE_DATA]);
const availableSlotsByVisitType = computed(() => store.state.user.availableSlotsByVisitType);

// Vuex actions
const getNumOfColumns = () => store.dispatch(SLOTS_COLUMNS);

// Methods
const updateAvailableSlots = async (optional) => {
  const data = {
    location: myLocation.value,
    time: myTime.value,
    week: myWeek.value,
    page: myPage.value,
    byXDays: optional ? optional.forceByXDays : byXDays.value
  };
  await store.dispatch(SLOTS_FILTER, data);
};

const filterLocationEtc = (data) => {
  myLocation.value = data.location;
  myTime.value = data.time;
  myWeek.value = data.week;
  if (data.byXDays !== undefined) {
    byXDays.value = data.byXDays;
  }
  updateAvailableSlots();
};

const filterPage = (data) => {
  myPage.value = data.page;
  byXDays.value = true;
  updateAvailableSlots();
};

const onResize = async () => {
  const colNum = numOfCol.value;
  // ensure visible content matches what screen reader announces
  numOfCol.value = await getNumOfColumns();
  if (numOfCol.value === 3) {
    // extra check required since phone browsers fire onResize event unexpectedly
    if (numOfCol.value !== colNum) {
      myPage.value = myWeek.value * 2;
    }
  } else {
    myPage.value = myWeek.value;
  }
  updateAvailableSlots({ forceByXDays: true });
};

// Watchers
watch(myWeek, (newVal) => {
  if (!byXDays.value) {
    if (numOfCol.value === 3) {
      myPage.value = newVal * 2;
      // re-render current days when page # is updated
      updateAvailableSlots({ forceByXDays: true });
    } else {
      myPage.value = newVal;
    }
  }
});

watch(myPage, (newVal) => {
  if (numOfCol.value === 3) {
    myWeek.value = Math.ceil((newVal - 1) / 2);
  } else {
    myWeek.value = newVal;
  }
});

// Lifecycle hooks
onMounted(() => {
  myLocation.value = slotsStates.value.defaultSelectOption;
  myTime.value = slotsStates.value.defaultSelectOption;
  window.addEventListener('resize', onResize);
  onResize();
});

onUnmounted(() => {
  window.removeEventListener('resize', onResize);
});
</script>


<style scoped lang="scss">
.slot-filters {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 1.5em;
  margin-bottom: 0.75em;
}
</style>
